import { LoadingButton } from '@mui/lab'
import { Box, Typography } from '@mui/material'
import { toast } from 'react-toastify'

import {
  useGetDynamicPricingVoteQuery,
  useSetDynamicPricingVoteAccuracyMutation,
} from 'generated/graphql'

interface DynamicPricingVoteSectionProps {
  bookingId: number
}

export const DynamicPricingVoteSection = ({ bookingId }: DynamicPricingVoteSectionProps) => {
  const { data, refetch } = useGetDynamicPricingVoteQuery({
    variables: { bookingId },
    fetchPolicy: 'network-only',
  })

  const [setVote, { loading }] = useSetDynamicPricingVoteAccuracyMutation()

  const vote = data?.dynamicPricingVote
  const hasVoted = !!vote
  const isAccurate = vote?.isAccurate

  const handleVote = async (accuracy: boolean) => {
    try {
      await setVote({
        variables: { bookingId, isAccurate: accuracy },
      })
      toast.success('Your vote has been recorded.')
      refetch()
    } catch {
      toast.error('Something went wrong while submitting your vote.')
    }
  }

  return (
    <Box mt={2} textAlign='center'>
      <Typography variant='body1' gutterBottom>
        Is the Consignment Fee from Dynamic Pricing accurate?
      </Typography>
      <Box display='flex' justifyContent='center' gap={2}>
        <LoadingButton
          variant={hasVoted && isAccurate ? 'contained' : 'outlined'}
          color='primary'
          disabled={hasVoted && isAccurate}
          loading={loading}
          onClick={() => handleVote(true)}>
          Yes
        </LoadingButton>
        <LoadingButton
          variant={hasVoted && !isAccurate ? 'contained' : 'outlined'}
          color='secondary'
          disabled={hasVoted && !isAccurate}
          loading={loading}
          onClick={() => handleVote(false)}>
          No
        </LoadingButton>
      </Box>
    </Box>
  )
}
